import type { Message } from "../../types/message";
import { MessageBubble } from "./message-bubble";

export default function TextMessage({ message }: { message: Message }) {
  return (
    <MessageBubble message={message}>
      <span className="whitespace-pre-wrap">{message.content}</span>
    </MessageBubble>
  );
}
